(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deals-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initStrip(root) {
    var track = root.querySelector('[data-deals-track]');
    var prev = root.querySelector('[data-deals-prev]');
    var next = root.querySelector('[data-deals-next]');
    if (!track || !prev || !next || track.dataset.dealsInit === '1') return;
    track.dataset.dealsInit = '1';

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function stepSize() {
      var item = track.querySelector('.deals-strip__item');
      var gap = 16;
      var width = item ? item.getBoundingClientRect().width : track.clientWidth * 0.4;
      return (width + gap) * 2;
    }

    function go(dir) {
      track.scrollBy({
        left: dir * stepSize(),
        behavior: reduce.matches ? 'auto' : 'smooth'
      });
    }

    function sync() {
      ticking = false;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    function queueSync() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(sync);
      }
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);
    sync();
  }

  function initAll() {
    var strips = document.querySelectorAll('[data-deals-strip]');
    for (var i = 0; i < strips.length; i++) {
      initStrip(strips[i]);
    }
  }

  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  'use strict';

  /* The drawer is rendered inside the sticky header, whose z-index (--z-header)
     caps everything inside it. global.js appends the shared .drawer-scrim to
     <body> at --z-drawer - 1, which is above the header, so the open drawer sat
     under the grey scrim: visible but untouchable on mobile. Hoisting the drawer
     and its own scrim to <body> puts them in the root stacking context. */
  function hoistDrawer() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer || drawer.parentNode === document.body) return;
    var scrim = drawer.nextElementSibling;
    document.body.appendChild(drawer);
    if (scrim && scrim.classList.contains('header-drawer-scrim')) document.body.appendChild(scrim);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hoistDrawer);
  } else {
    hoistDrawer();
  }
  document.addEventListener('shopify:section:load', hoistDrawer);

  function closeAllNav(except) {
    var openItems = document.querySelectorAll('[data-nav-parent].is-open');
    Array.prototype.forEach.call(openItems, function (item) {
      if (item === except) return;
      item.classList.remove('is-open');
      var btn = item.querySelector('[data-nav-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (toggle) {
      var item = toggle.closest('[data-nav-parent]');
      if (!item) return;
      var willOpen = !item.classList.contains('is-open');
      closeAllNav(item);
      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('[data-nav-parent]')) {
      closeAllNav(null);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-nav-parent].is-open');
    if (open) {
      var btn = open.querySelector('[data-nav-toggle]');
      closeAllNav(null);
      if (btn) btn.focus();
    }
  });

  document.addEventListener('wbtc:cart:updated', function (event) {
    var count = event.detail && typeof event.detail.item_count === 'number' ? event.detail.item_count : null;
    if (count === null) return;
    var badges = document.querySelectorAll('[data-cart-count]');
    Array.prototype.forEach.call(badges, function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var imgs = [];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ticking = false;

  function update() {
    ticking = false;
    if (!imgs.length) return;
    if (reduce.matches) {
      for (var i = 0; i < imgs.length; i++) {
        imgs[i].style.transform = '';
      }
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight || 1;
    for (var j = 0; j < imgs.length; j++) {
      var frame = imgs[j].parentElement;
      if (!frame) continue;
      var box = frame.getBoundingClientRect();
      var center = box.top + box.height / 2;
      var progress = (center - vh / 2) / (vh / 2);
      if (progress > 1) progress = 1;
      if (progress < -1) progress = -1;
      imgs[j].style.transform = 'translate3d(0, ' + (progress * -24).toFixed(1) + 'px, 0)';
    }
  }

  function queueUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  function collect() {
    imgs = Array.prototype.slice.call(
      document.querySelectorAll('[data-hero-parallax] .hero__img')
    );
    queueUpdate();
  }

  window.addEventListener('scroll', queueUpdate, { passive: true });
  window.addEventListener('resize', queueUpdate);
  if (typeof reduce.addEventListener === 'function') {
    reduce.addEventListener('change', queueUpdate);
  }
  document.addEventListener('shopify:section:load', collect);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
  'use strict';

  var pending = false;

  function getSection(node) {
    return node.closest('[data-cart-section]');
  }

  function dispatchCount(count) {
    document.dispatchEvent(
      new CustomEvent('wbtc:cart:updated', { detail: { item_count: count } })
    );
  }

  function changeLine(section, line, quantity, delta) {
    if (pending) return;
    pending = true;
    section.classList.add('is-updating');

    var current = parseInt(section.getAttribute('data-cart-line-count'), 10) || 0;
    var optimistic = current + delta;
    if (optimistic < 0) optimistic = 0;
    dispatchCount(optimistic);

    var url = section.getAttribute('data-cart-change-url') + '.js';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart change failed');
        return response.json();
      })
      .then(function (cart) {
        dispatchCount(cart.item_count);
        window.location.reload();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function lineNumber(row) {
    return parseInt(row.getAttribute('data-cart-line'), 10);
  }

  function originalQty(input) {
    return parseInt(input.getAttribute('data-original-qty'), 10) || 0;
  }

  document.addEventListener('click', function (event) {
    var stepper = event.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
    if (stepper) {
      var section = getSection(stepper);
      if (!section) return;
      var row = stepper.closest('[data-cart-line]');
      var input = row.querySelector('[data-cart-qty-input]');
      var qty = parseInt(input.value, 10);
      if (isNaN(qty)) qty = originalQty(input);
      var next = stepper.hasAttribute('data-cart-qty-minus') ? qty - 1 : qty + 1;
      if (next < 0) next = 0;
      input.value = next;
      changeLine(section, lineNumber(row), next, next - originalQty(input));
      return;
    }

    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      var removeSection = getSection(remove);
      if (!removeSection) return;
      event.preventDefault();
      var removeRow = remove.closest('[data-cart-line]');
      var removeInput = removeRow.querySelector('[data-cart-qty-input]');
      changeLine(removeSection, lineNumber(removeRow), 0, -originalQty(removeInput));
    }
  });

  /* Personalized gift card: the $2.00 add-on product is added to or removed from
     the cart by the checkbox; the message rides along as a line item property so
     it prints on the packing slip.

     No page reload on toggle -- the write goes through the cart AJAX API and the
     page is patched in place. Reloading threw away whatever the shopper had
     already typed and made the tick box feel broken. */
  var GIFT_HANDLE = 'personalized-gift-card';
  var giftTimer = null;
  var giftDirty = false;
  var giftBusy = false;

  function giftBlock() {
    return document.querySelector('[data-gift-block]');
  }

  function giftCount() {
    var block = giftBlock();
    if (!block) return;
    var area = block.querySelector('[data-gift-message]');
    var out = block.querySelector('[data-gift-count]');
    if (area && out) out.textContent = area.value.length;
  }

  function giftLinesOf(cart) {
    var lines = [];
    (cart.items || []).forEach(function (it, i) {
      if (it.handle === GIFT_HANDLE) { lines.push(i + 1); }
    });
    return lines;
  }

  function giftLineOf(cart) {
    var lines = giftLinesOf(cart);
    return lines.length ? lines[0] : 0;
  }

  /* Line numbers re-index the moment another line is removed, so a stale one
     rewrites the wrong product. The line item key is variant + properties, so
     it is unique, and a key gone stale simply 404s. Anything that has to fire
     without waiting for a fresh cart -- the page-exit beacon -- goes by key. */
  function giftKeyOf(cart) {
    var found = '';
    (cart.items || []).forEach(function (it) {
      if (!found && it.handle === GIFT_HANDLE) { found = it.key; }
    });
    return found;
  }

  function stampGift(block, cart) {
    if (!block) return;
    block.setAttribute('data-gift-line', giftLineOf(cart));
    block.setAttribute('data-gift-key', giftKeyOf(cart));
  }

  function giftQtyOf(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (it) {
      if (it.handle === GIFT_HANDLE) { qty += it.quantity; }
    });
    return qty;
  }

  function changeGiftLine(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true
    }).then(function (r) { return r.json(); });
  }

  /* One card, one line, quantity one.

     /cart/add.js opens a NEW line whenever the properties differ from the line
     already in the cart, and the toggle used to call it without ever checking
     whether a card was already there. A second cart tab, or a line still
     carrying the old "Gift card message" key, put two $2 cards on the order.
     Every tick now comes through here instead.

     Removals run highest line number first: change.js re-indexes the cart after
     each write, so deleting low-to-high would shift the ones still to go.
     Properties left out of a change.js body are preserved, so pass a message
     only when there is one to write. */
  function collapseGift(cart, message) {
    var lines = giftLinesOf(cart);
    if (!lines.length) return Promise.resolve(cart);
    var keep = lines[0];
    var chain = Promise.resolve(cart);
    lines.slice(1).reverse().forEach(function (ln) {
      chain = chain.then(function () { return changeGiftLine({ line: ln, quantity: 0 }); });
    });
    if (lines.length > 1 || giftQtyOf(cart) > 1 || message != null) {
      chain = chain.then(function () {
        var body = { line: keep, quantity: 1 };
        if (message != null) body.properties = { 'Card message': message };
        return changeGiftLine(body);
      });
    }
    return chain;
  }

  function removeGift(cart) {
    var chain = Promise.resolve(cart);
    giftLinesOf(cart).reverse().forEach(function (ln) {
      chain = chain.then(function () { return changeGiftLine({ line: ln, quantity: 0 }); });
    });
    return chain;
  }

  /* A cart can walk in already holding two add-on lines -- built before this
     fix, or by a second tab mid-session. Collapse it on load, before anyone
     reaches checkout. */
  var giftHealed = false;
  function giftSelfHeal() {
    var block = giftBlock();
    if (!block || giftHealed) return;
    giftHealed = true;
    getCart().then(function (cart) {
      stampGift(block, cart);
      if (giftLinesOf(cart).length < 2 && giftQtyOf(cart) < 2) return;
      var area = block.querySelector('[data-gift-message]');
      giftBusy = true;
      return collapseGift(cart, area ? area.value : null)
        .then(getCart)
        .then(function (fresh) {
          stampGift(block, fresh);
          repaintCart(fresh);
          giftBusy = false;
        });
    }).catch(function () { giftBusy = false; });
  }

  /* Repaint everything on the page that carries the total. The add-on is not
     case-eligible, so the 12-bottle progress block cannot move and is left alone. */
  function repaintCart(cart) {
    var money = cart.total_price;
    var els = document.querySelectorAll('[data-cart-total]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = formatMoney(money);
    }
    dispatchCount(cart.item_count - giftQtyOf(cart) - bagQtyOf(cart));
  }

  /* The theme prints money server side; mirror that format here rather than
     guessing at a locale. Whole cents, two decimals, thousands separated. */
  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US',
      { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function saveGiftMessage(then) {
    var block = giftBlock();
    if (!block) return then && then();
    var area = block.querySelector('[data-gift-message]');
    if (!area) return then && then();
    giftDirty = false;
    /* Read the cart rather than trusting data-gift-line, which goes stale the
       moment another line is removed. collapseGift no-ops on an empty cart. */
    getCart()
      .then(function (cart) { return collapseGift(cart, area.value); })
      .then(getCart)
      .then(function (cart) { stampGift(block, cart); })
      .then(function () { then && then(); })
      .catch(function () { then && then(); });
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-gift-toggle]');
    if (!toggle) return;
    var block = giftBlock();
    if (!block) return;
    if (giftBusy) { toggle.checked = !toggle.checked; return; }
    giftBusy = true;
    toggle.disabled = true;
    block.classList.add('is-saving');

    var body = block.querySelector('[data-gift-body]');
    var area = block.querySelector('[data-gift-message]');
    var wanted = toggle.checked;
    if (body) body.hidden = !wanted;

    /* Always look at the real cart first. Ticking a box on a page rendered
       before another tab added the card is what produced two cards on one
       order; add.js only runs when the cart genuinely has none. */
    var request = getCart().then(function (cart) {
      if (!wanted) return removeGift(cart);
      if (giftLinesOf(cart).length) return collapseGift(cart, area ? area.value : '');
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(block.getAttribute('data-gift-variant'), 10),
            quantity: 1,
            properties: { 'Card message': area ? area.value : '' }
          }]
        })
      });
    });

    request
      .then(function () { return getCart(); })
      .then(function (cart) {
        stampGift(block, cart);
        repaintCart(cart);
        if (wanted && area) { try { area.focus(); } catch (e) {} }
      })
      .catch(function () {
        /* Put the box back where the cart actually is. */
        toggle.checked = !wanted;
        if (body) body.hidden = wanted;
      })
      .then(function () {
        giftBusy = false;
        toggle.disabled = false;
        block.classList.remove('is-saving');
      });
  });

  document.addEventListener('input', function (event) {
    if (!event.target.closest('[data-gift-message]')) return;
    giftCount();
    giftDirty = true;
    clearTimeout(giftTimer);
    giftTimer = setTimeout(saveGiftMessage, 700);
  });

  /* Don't let a half-typed message get left behind by a fast checkout click. */
  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('button[name="checkout"]');
    if (!checkout || !giftDirty) return;
    event.preventDefault();
    clearTimeout(giftTimer);
    saveGiftMessage(function () { checkout.click(); });
  }, true);

  /* The accelerated buttons -- Shop Pay and friends -- live in an iframe, so
     their click never reaches this document and the guard above cannot see it.
     Focus does leave the textarea when the shopper clicks into that iframe, so
     blur is the one event still worth listening to on that path. Save at once
     instead of waiting out the debounce. */
  document.addEventListener('blur', function (event) {
    if (!event.target.closest || !event.target.closest('[data-gift-message]')) return;
    if (!giftDirty) return;
    clearTimeout(giftTimer);
    saveGiftMessage();
  }, true);

  /* Gift bag: the $3.00 add-on (handle gift-bag). One line, quantity = number of
     bags. Same rules as the card: always read the real cart first, add.js only
     when there is no bag line yet, extra lines removed highest first. */
  var BAG_HANDLE = 'gift-bag';
  var bagBusy = false;

  function bagLinesOf(cart) {
    var lines = [];
    (cart.items || []).forEach(function (it, i) {
      if (it.handle === BAG_HANDLE) { lines.push(i + 1); }
    });
    return lines;
  }

  function bagQtyOf(cart) {
    var qty = 0;
    (cart.items || []).forEach(function (it) {
      if (it.handle === BAG_HANDLE) { qty += it.quantity; }
    });
    return qty;
  }

  function setBags(cart, qty, variant) {
    var lines = bagLinesOf(cart);
    if (!lines.length) {
      if (qty < 1) return Promise.resolve();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant, quantity: qty }] })
      });
    }
    var chain = Promise.resolve();
    lines.slice(1).reverse().forEach(function (ln) {
      chain = chain.then(function () { return changeGiftLine({ line: ln, quantity: 0 }); });
    });
    return chain.then(function () { return changeGiftLine({ line: lines[0], quantity: qty }); });
  }

  document.addEventListener('change', function (event) {
    var toggle = event.target.closest('[data-bag-toggle]');
    var picker = event.target.closest('[data-bag-qty]');
    if (!toggle && !picker) return;
    var block = document.querySelector('[data-bag-block]');
    if (!block) return;
    var box = block.querySelector('[data-bag-toggle]');
    var sel = block.querySelector('[data-bag-qty]');
    var body = block.querySelector('[data-bag-body]');
    if (bagBusy) { if (toggle) toggle.checked = !toggle.checked; return; }
    bagBusy = true;
    box.disabled = true;
    if (sel) sel.disabled = true;
    block.classList.add('is-saving');

    var wanted = box.checked;
    if (toggle && wanted && sel) sel.value = '1';
    var qty = wanted ? parseInt(sel ? sel.value : '1', 10) || 1 : 0;
    if (body) body.hidden = !wanted;

    getCart()
      .then(function (cart) {
        return setBags(cart, qty, parseInt(block.getAttribute('data-bag-variant'), 10));
      })
      .then(getCart)
      .then(function (cart) {
        var have = bagQtyOf(cart);
        box.checked = have > 0;
        if (body) body.hidden = have < 1;
        if (sel && have > 0) sel.value = String(have);
        repaintCart(cart);
      })
      .catch(function () {
        box.checked = !wanted;
        if (body) body.hidden = wanted;
      })
      .then(function () {
        bagBusy = false;
        box.disabled = false;
        if (sel) sel.disabled = false;
        block.classList.remove('is-saving');
      });
  });

  document.addEventListener('DOMContentLoaded', function () {
    giftCount();
    giftSelfHeal();
  });
  giftCount();
  giftSelfHeal();

  /* ---- Delivery timing ------------------------------------------------ */
  /* The radios and the day picker are only controls. What posts is the three
     hidden inputs, rewritten on every change: on "right away" the date and time
     go up empty, which is what actually clears them off the cart - Shopify
     keeps any attribute it is not sent. "Tomorrow" posts as Later date with
     tomorrow's date. */
  var WHEN_CLOSED = [6];               /* Saturday - the shop is shut */
  var WHEN_SHORT = 5;                  /* Friday - shut before evening */
  var WHEN_CLOSED_MSG = 'We are closed on Saturday. Please pick another day.';

  function whenCard() { return document.querySelector('[data-cart-when]'); }

  function whenPad(n) { return (n < 10 ? '0' : '') + n; }

  function whenYmd(d) {
    return d.getFullYear() + '-' + whenPad(d.getMonth() + 1) + '-' + whenPad(d.getDate());
  }

  /* The shop's calendar, not the shopper's: "tomorrow" is tomorrow in New York. */
  function whenToday() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day);
    } catch (e) {
      var n = new Date();
      return new Date(n.getFullYear(), n.getMonth(), n.getDate());
    }
  }

  function whenPlus(days) {
    var d = whenToday(); d.setDate(d.getDate() + days);
    return d;
  }

  /* A date input's value is a bare Y-M-D with no zone. Parsing it with the Date
     constructor would read it as UTC and slide it a day back in New York, so the
     parts are split by hand. */
  function whenDow(value) {
    var p = (value || '').split('-');
    if (p.length !== 3) return -1;
    return new Date(+p[0], +p[1] - 1, +p[2]).getDay();
  }

  function whenMode(card) {
    var on = card.querySelector('[data-when-mode]:checked');
    return on ? on.value : 'now';
  }

  function whenError(text) {
    var card = whenCard();
    if (!card) return;
    var err = card.querySelector('[data-when-err]');
    if (!err) return;
    err.textContent = text || '';
    err.hidden = !text;
  }

  /* Show the right half of the card and rewrite the three posted values. */
  function whenSync() {
    var card = whenCard();
    if (!card) return;
    var tomorrow = whenPlus(1);
    var mode = whenMode(card);
    var date = card.querySelector('[data-when-date]');

    /* No "tomorrow" on a Friday. */
    var tomorrowOff = WHEN_CLOSED.indexOf(tomorrow.getDay()) !== -1;
    var tomorrowOpt = card.querySelector('[data-when-tomorrow-opt]');
    if (tomorrowOpt) tomorrowOpt.hidden = tomorrowOff;
    if (mode === 'tomorrow' && tomorrowOff) {
      mode = 'now';
      card.querySelector('[data-when-mode][value="now"]').checked = true;
    }

    card.querySelector('[data-when-body]').hidden = mode === 'now';
    card.querySelector('[data-when-day]').hidden = mode !== 'later';

    var day = '';
    if (mode === 'tomorrow') day = whenYmd(tomorrow);
    if (mode === 'later') day = date.value;

    var half = '';
    Array.prototype.forEach.call(card.querySelectorAll('[data-when-time]'), function (el) {
      el.disabled = el.value === 'Evening' && whenDow(day) === WHEN_SHORT;
      if (el.disabled) el.checked = false;
      if (el.checked) half = el.value;
    });

    var out = { timing: 'Right away', date: '', time: '' };
    if (mode !== 'now') out = { timing: 'Later date', date: day, time: half };
    Array.prototype.forEach.call(card.querySelectorAll('[data-when-out]'), function (el) {
      el.value = out[el.getAttribute('data-when-out')];
    });
    if (mode === 'now') whenError('');
  }

  /* Returns true when the card is in a state we can send to checkout. */
  function whenValid() {
    var card = whenCard();
    if (!card) return true;
    whenSync();
    if (whenMode(card) !== 'later') return true;
    var date = card.querySelector('[data-when-date]');
    var bad = '';
    if (!date.value || date.value < date.min || date.value > date.max) bad = 'Please pick a day.';
    else if (WHEN_CLOSED.indexOf(whenDow(date.value)) !== -1) bad = WHEN_CLOSED_MSG;
    whenError(bad);
    if (bad) { try { date.focus(); } catch (e) {} }
    return !bad;
  }

  function whenInit() {
    var card = whenCard();
    if (!card) return;
    var date = card.querySelector('[data-when-date]');
    if (date && !date.min) {
      /* Tomorrow has its own choice, so the picker starts the day after, and
         we stop taking requests two months out. */
      date.min = whenYmd(whenPlus(2));
      date.max = whenYmd(whenPlus(60));
    }
    /* A cart left overnight. The server guessed the choice from its own clock;
       settle it against New York's, and drop a day that has already come. */
    var saved = card.querySelector('[data-when-out="date"]').value;
    if (saved && whenMode(card) !== 'now') {
      var pick = 'later';
      if (saved <= whenYmd(whenToday())) pick = 'now';
      else if (saved === whenYmd(whenPlus(1))) pick = 'tomorrow';
      card.querySelector('[data-when-mode][value="' + pick + '"]').checked = true;
      if (date) date.value = pick === 'later' ? saved : '';
    }
    whenSync();
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t.closest || !t.closest('[data-cart-when]')) return;
    whenSync();
    whenError(t.hasAttribute('data-when-date') && t.value &&
      WHEN_CLOSED.indexOf(whenDow(t.value)) !== -1 ? WHEN_CLOSED_MSG : '');
  });

  /* Same guard the gift message uses - stop the click rather than let a broken
     date reach checkout. */
  document.addEventListener('click', function (event) {
    var checkout = event.target.closest('button[name="checkout"]');
    if (!checkout) return;
    if (!whenValid()) event.preventDefault();
  }, true);

  document.addEventListener('DOMContentLoaded', whenInit);
  whenInit();

  /* ---- Autosave, and the flush on the way out ------------------------- */
  /* Everything on this page used to reach Shopify only when our own cart form
     was submitted -- and, for the card message, 700ms after the last keystroke.
     Any exit that was not the Check out button skipped both: the accelerated
     buttons post their own checkout straight from the cart, and the Shop app
     never runs this script at all. Order #1092 (2026-09-09) left that way and
     landed with an empty card message and no substitution preference, while
     every order that went through the button carried both.

     Three belts: write the attributes as soon as they are picked, write the
     message on blur as well as on the debounce, and beacon anything still
     unwritten as the page goes away. */

  function cartForm() { return document.querySelector('form.cart-form'); }

  /* Mirroring the real form beats re-deriving the values and drifting out of
     step with it. */
  function attrsBody() {
    var form = cartForm();
    if (!form || !window.FormData || !window.URLSearchParams) return null;
    var out = new URLSearchParams();
    var any = false;
    new FormData(form).forEach(function (value, name) {
      if (name.indexOf('attributes[') !== 0) return;
      out.append(name, value);
      any = true;
    });
    return any ? out.toString() : null;
  }

  var attrsTimer = null;
  function saveAttrs() {
    var body = attrsBody();
    if (!body) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      },
      body: body,
      keepalive: true
    }).catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t.closest) return;
    if (!t.closest('.cart-sub') && !t.closest('[data-cart-when]')) return;
    clearTimeout(attrsTimer);
    attrsTimer = setTimeout(saveAttrs, 150);
  });

  /* The note (2026-10-11). It used to reach Shopify only through our own Check out
     button. With fast-pay buttons on the page it is written on change and on blur too,
     and beaconed on the way out. */
  function noteBody() {
    var area = document.getElementById('CartNote');
    if (!area || !window.URLSearchParams) return null;
    var out = new URLSearchParams();
    out.append('note', area.value);
    return out.toString();
  }
  var noteSaved = null;
  function saveNote() {
    var body = noteBody();
    if (body === null || body === noteSaved) return;
    noteSaved = body;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: body,
      keepalive: true
    }).catch(function () { noteSaved = null; });
  }
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'CartNote') saveNote();
  });
  document.addEventListener('blur', function (event) {
    if (event.target && event.target.id === 'CartNote') saveNote();
  }, true);

  /* ---- Zip check -------------------------------------------------------- */
  /* Bands copied from bucketForZip in the wbtc-nyc-zip-filter checkout function.
     Change one, change the other. */
  var ZIP_CROWN = { '11213': 1, '11216': 1, '11225': 1, '11238': 1 };
  function zipBucket(z) {
    if (!/^\d{5}$/.test(z)) return 'bad';
    if (ZIP_CROWN[z]) return 'crown';
    var n = parseInt(z, 10);
    if (n >= 11201 && n <= 11256) return 'brooklyn';
    if (n >= 10001 && n <= 10282) return 'nyc';
    if (n === 11001 || n === 11004 || n === 11005 || n === 11040) return 'nyc';
    if (n >= 11101 && n <= 11109) return 'nyc';
    if (n >= 11351 && n <= 11439) return 'nyc';
    if (n >= 11691 && n <= 11697) return 'nyc';
    if (n >= 10451 && n <= 10475) return 'nyc';
    if (n >= 10301 && n <= 10314) return 'nyc';
    return 'out';
  }
  var ZIP_TEXT = {
    crown: 'Crown Heights delivery: $5 flat. Pickup at 511 Empire Blvd is free.',
    brooklyn: 'Brooklyn delivery: $10 flat. Pickup at 511 Empire Blvd is free.',
    nyc: 'New York City delivery: $20 flat. Pickup at 511 Empire Blvd is free.',
    out: 'We deliver within New York City. Pickup at 511 Empire Blvd, Crown Heights, is free.',
    bad: 'Type a five digit zip code.'
  };
  function zipRun(save) {
    var box = document.querySelector('[data-cart-zip]');
    if (!box) return;
    var input = box.querySelector('[data-zip-input]');
    var out = box.querySelector('[data-zip-out]');
    var z = (input.value || '').replace(/\D/g, '').slice(0, 5);
    if (!z) { out.textContent = ''; return; }
    out.textContent = ZIP_TEXT[zipBucket(z)];
    if (save && z.length === 5) { try { window.localStorage.setItem('wbtc_zip', z); } catch (e) {} }
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-zip-check]')) zipRun(true);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches || !event.target.matches('[data-zip-input]')) return;
    event.preventDefault();
    zipRun(true);
  });
  function zipInit() {
    var input = document.querySelector('[data-zip-input]');
    if (!input || input.value) return;
    var z = '';
    try { z = window.localStorage.getItem('wbtc_zip') || ''; } catch (e) {}
    if (!z && window.WBTC_CUSTOMER && window.WBTC_CUSTOMER.zip) z = String(window.WBTC_CUSTOMER.zip).slice(0, 5);
    if (z) { input.value = z; zipRun(false); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', zipInit); else zipInit();

  /* A fetch started as the page unloads is not guaranteed to leave, keepalive
     or not. sendBeacon is. The message goes by line item key, so a key that has
     gone stale 404s rather than rewriting a bottle. */
  function flushOnExit() {
    if (!navigator.sendBeacon || !window.Blob) return;
    var body = attrsBody();
    if (body) {
      navigator.sendBeacon('/cart/update.js',
        new Blob([body], { type: 'application/x-www-form-urlencoded' }));
    }
    var nb = noteBody();
    if (nb !== null && nb !== noteSaved) {
      noteSaved = nb;
      navigator.sendBeacon('/cart/update.js',
        new Blob([nb], { type: 'application/x-www-form-urlencoded' }));
    }
    if (!giftDirty) return;
    var block = giftBlock();
    if (!block) return;
    var area = block.querySelector('[data-gift-message]');
    var key = block.getAttribute('data-gift-key');
    if (!area || !key) return;
    giftDirty = false;
    navigator.sendBeacon('/cart/change.js', new Blob([JSON.stringify({
      id: key,
      quantity: 1,
      properties: { 'Card message': area.value }
    })], { type: 'application/json' }));
  }

  window.addEventListener('pagehide', flushOnExit);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flushOnExit();
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var section = getSection(input);
    if (!section) return;
    var row = input.closest('[data-cart-line]');
    var next = parseInt(input.value, 10);
    if (isNaN(next) || next < 0) next = 0;
    input.value = next;
    if (next === originalQty(input)) return;
    changeLine(section, lineNumber(row), next, next - originalQty(input));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function () {
  'use strict';

  function hydrate(root) {
    if (!root || root.dataset.performed === 'true' || root.dataset.loaded === 'true') return;
    var url = root.dataset.url;
    if (!url) return;

    function load() {
      if (root.dataset.loaded === 'true') return;
      root.dataset.loaded = 'true';
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-related-products]');
          if (fresh && fresh.innerHTML.trim().length) {
            root.innerHTML = fresh.innerHTML;
            root.querySelectorAll('.reveal').forEach(function (el) {
              el.classList.add('is-in');
            });
          }
        })
        .catch(function () {
          root.dataset.loaded = 'false';
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            load();
          }
        });
      }, { rootMargin: '400px 0px' });
      observer.observe(root);
    } else {
      load();
    }
  }

  document.querySelectorAll('[data-related-products]').forEach(hydrate);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-related-products]');
    if (root) hydrate(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
